import { render, staticRenderFns } from "./assetCleanupDetail.vue?vue&type=template&id=89b3e62e"
import script from "./assetCleanupDetail.vue?vue&type=script&lang=js"
export * from "./assetCleanupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports